export const SUMMARY_CARDS = (data) => {

  return (
    [
      {
        key: 'responses',
        icon: "SVG-userprofile-tick",
        theme: 'neutral',
        label: 'Participants',
        value: data.responses && data.responses.total ? data.responses.total : "",
        description: 'unique leaders whose 360 was conducted',
      },
      {
        key: 'stakeholders',
        icon: "SVG-peoples",
        theme: 'teal',
        label: 'Stakeholders',
        value: data.stakeholders && data.stakeholders.total ? data.stakeholders.total : "",
        description: `raters excluding self · ${data.stakeholders && data.stakeholders.raterGroupsInScope} per participant`,
      },
      {
        key: 'categoriesFavorable',
        icon: "SVG-Verified-tick",
        theme: 'teal',
        label: '% Categories Favorable',
        value: `${data.categoriesFavorable && data.categoriesFavorable.pctCategoriesFavorable ? Math.trunc(data.categoriesFavorable.pctCategoriesFavorable) : ""}%`,
        description: 'mean ≥ 4 of 6',
      },
      {
        key: 'commentsLeft',
        icon: "SVG-Comments-content",
        theme: 'orange',
        label: 'Comments Left',
        value: `${data.comments && data.comments.strengthsCoveragePct ? Math.trunc(data.comments.strengthsCoveragePct) : ""}% · ${data.comments && data.comments.developmentCoveragePct ? Math.trunc(data.comments.developmentCoveragePct) : ""}%`,
        description: 'strengths · development areas',
      },
    ]
  );

} 

export const SUMMARY_NOTE =
  '1 of 6 categories sit below the favorable threshold and warrant a focused development conversation.';
